'use client';

import React, { useState, useCallback } from 'react';

import { useTranslations } from 'next-intl';

import CopyIcon from '@/assets/icons/copy.svg';
import { P } from '@/components/shared/Typography';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';

function ReferralLink() {
  const t = useTranslations();
  const [copied, setCopied] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const referralCode = 'DU729A71';

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(referralCode);
      setCopied(true);
      setTooltipOpen(true);

      setTimeout(() => {
        setCopied(false);
        setTooltipOpen(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }, [referralCode]);

  return (
    <div className="w-full bg-accent rounded-md flex items-center">
      <p className="w-full max-w-42 font-bold px-5">
        {t('profile.referralLink.myReferralLink')}
      </p>
      <div className="w-full h-full px-3 py-2.5 bg-muted-foreground border border-muted-foreground">
        <P className="text-background">{referralCode}</P>
      </div>
      <Popover open={tooltipOpen} onOpenChange={setTooltipOpen}>
        <PopoverTrigger asChild>
          <div
            className={`p-3.5 rounded-md rounded-l-none cursor-pointer transition-colors ${
              copied ? 'bg-primary-hover' : 'bg-primary hover:bg-primary-hover'
            }`}
            onClick={handleCopy}
          >
            <CopyIcon />
          </div>
        </PopoverTrigger>
        <PopoverContent
          className="w-auto px-3 py-2 bg-primary-hover border-primary-hover text-primary-foreground text-sm font-medium"
          side="top"
          sideOffset={8}
        >
          {t('profile.referralLink.copied')}
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default ReferralLink;
